<div class="circular-loader">
  <div class="loader"></div>
  <span class="loading-text">Searching Buses...</span>
</div>
